import React from 'react';
import FansDashboardPage from '../components/FansDashboardPage';

const FanDashboardApp = (props) => <FansDashboardPage {...props} />;

export default FanDashboardApp;
